import { useCallback } from "react";
import { useSelector } from "react-redux";

import AuthenticationManager from "./AuthenticationManager";
import { useNavigateTo } from "../Routes/RoutesContext";

const AuthenticationWall = props => {
  const { children } = props;
  const isUser = useSelector(({ viewer }) => viewer.isUser);
  const navigateTo = useNavigateTo();

  const handleAuthenticationManagerHidden = useCallback(() => {
    navigateTo("/");
  }, [navigateTo]);

  if (isUser) return children;

  return <AuthenticationManager onClose={handleAuthenticationManagerHidden} />;
};

export default AuthenticationWall;
